import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';
import { Observable } from 'rxjs';

import { BarnOverviewComponent } from './components/barn-overview/barn-overview.component';
import { SettingsResolver } from './resolvers/settings.resolver';

export const settingsRoutes: Routes = [
  {
    path: 'barn',
    component: BarnOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      isLoaded: mapToResolve<Observable<boolean>>(SettingsResolver),
    },
    data: { name: 'barn-overview' },
  },
];
